/**
 * API Client - Centralized HTTP client for all API calls
 * 
 * GOVERNANCE RULE: All screens must call APIs through this service layer.
 * Do NOT create new API formats or mock APIs outside this layer.
 * 
 * Base client with auth interceptors, error handling, and request/response logging.
 */
import axios from 'axios';
import { API_BASE as API_BASE_URL } from '../../lib/api';


const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Request interceptor - attach auth token
apiClient.interceptors.request.use(
  (config) => {
    // Read from both storages — supports session-only (rememberMe=false) and persistent sessions
    const token = localStorage.getItem('retailcliq_token') || sessionStorage.getItem('retailcliq_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle 401 and errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear tokens from both storages to prevent the reload-rehydrate-401 loop
      ['retailcliq_token', 'retailcliq_user', 'rcq_access_token', 'rcq_user'].forEach(k => {
        try { localStorage.removeItem(k); sessionStorage.removeItem(k); } catch (_) {}
      });
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
